import "../../css/guest-selector.css"
import React, {Dispatch, FC, SetStateAction, useState} from "react";
import {toast} from "react-toastify";
import {API_URL, EVENT_NAME, USER_ID} from "../../../../constants/ApiConstants";
import Input from "../../../../components/form/Input";
import {Guest, GuestResponse} from "../../../../types/Guests";

interface MyComponentProps {
    setGuest: Dispatch<SetStateAction<Guest | undefined>>
    setSearchResults: Dispatch<SetStateAction<GuestResponse | null>>
}

const GuestSelector: FC<MyComponentProps> = ({setGuest, setSearchResults}) => {
    const [guestName, setGuestName] = useState<string>("");

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        setGuestName(value);
    }

    // @ts-ignore
    const handleSubmitGuestName = async (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (!guestName || guestName.length < 2) {
            toast.error("Please enter at least two characters")
            return;
        }

        if (!guestName.includes(" ")) {
            toast.error("Please enter your first and last name")
            return;
        }

        fetchGuests().then((response) => {
            if (!response || response.count === 0) {
                setGuestName("");
                toast.error("Invite not found")
            } else if (response && response.count !== 1) {
                setSearchResults(response);
            } else if (response && response.count === 1) {
                setGuest(response.items[0]);
            }
        })

    };

    const fetchGuests = async () => {

        const requestOptions: RequestInit = {
            method: "GET",
        }

        const url = new URL(`${API_URL}/users/${USER_ID}/events/${EVENT_NAME}/guests`);

        const params = {
            guestName: guestName,
        }

        const searchParams = new URLSearchParams(params);
        url.search = searchParams.toString();

        try {
            const response = await fetch(url, requestOptions);

            if (response.ok) {
                setGuestName("");
                return await response.json();
            } else {
                console.log(`Guest ${guestName} not found`)
                toast.error("Guest not found");
                setGuestName("");
            }
        } catch (error) {
            console.log('Error fetching guests:', error);
            toast.error("An unexpected error has occurred, please try again later");
        }
    }

    return (
        <div className="rsvp__guestSelector">
            <form className="form__input" onSubmit={handleSubmitGuestName}>
                <h2>Please enter your name to find your invite</h2>
                <div className="input__row">
                    <Input
                        type="text"
                        name="guestSelector"
                        value={guestName}
                        onChange={handleChange}
                    />
                    <Input
                        type="submit"
                        name="searchGuests"
                        value="Search"
                        className="input__btn"
                        onClick={handleSubmitGuestName}
                        disabled={guestName.length < 2}
                    />
                </div>
            </form>
        </div>
    );
};

export default GuestSelector;
